module.exports = __webpack_public_path__ + "assets/img/27_1283.b53e63a9.jpg";